import styled from "@emotion/styled";

interface SizeFitLabelBannerProps {
  fullWidth?: boolean;
  fixedInSizeOverlay?: boolean;
}

export const SizeFitLabelBanner = styled.div<SizeFitLabelBannerProps>`
  display: flex;
  width: ${({ fullWidth }) => (fullWidth ? "calc(100% + 32px)" : "100%")};
  margin-left: ${({ fullWidth }) => (fullWidth ? "-16px" : "0")};
  margin-right: ${({ fullWidth }) => (fullWidth ? "-16px" : "0")};
  margin-top: ${({ fullWidth }) => (fullWidth ? "0" : "8px")};
  padding: 4px 0;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.tone.black};
  background: var(--Semantic-UI-Secondary-Light-Yellow, #fceccf);

  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: 8px;
    margin-bottom: ${({ fixedInSizeOverlay }) =>
      fixedInSizeOverlay ? "8px" : "16px"};
  }

  ${({ fixedInSizeOverlay }) =>
    fixedInSizeOverlay &&
    `
    position: fixed;
    bottom: 88px;
    margin-left: -16px;
  `}
`;
